var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.breadcrumbs),function(link,index){return _c('li',{key:index},[_c('router-link',{staticClass:"breadcrumbs__link",attrs:{"to":link.url}},[_vm._v(_vm._s(link.text))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }